import Dealer from '@/state/Dealership';

const price = (value, decimals) => {

    const intl = new Intl.NumberFormat(Dealer.getCulture(), {
        style: 'currency',
        currency: Dealer.getCurrency(),
        maximumFractionDigits: decimals || 0,
		minimumFractionDigits: decimals || 0
    });

    return intl.format(value);
};
const amount = (value, decimals) => {
    const intl = new Intl.NumberFormat(Dealer.getCulture(), {
        maximumFractionDigits: decimals || 0,
		minimumFractionDigits: decimals || 0
    });

    return intl.format(value);
};
const date = d => d ? getFormatYYYYMMDD(new Date(d)) : null;

const debounce = (func, wait, immediate) => {
	var timeout;

	return function() {
		var context = this, args = arguments;
		var later = function() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
};

const validPhone = input => {
	const raw = (input || "").replace(/\s/g, "");

	return /^\+417\d{8}$/.test(raw);
};

const fulfillment = code => {
	switch (code) {
		case "FULFILLED":
			return "Fulfilled";
		case "IN_PROGRESS":
			return "In progress";
		case "OPEN":
			return "Open";
		case "PARTIALLY_FULFILLED":
			return "Partially fulfilled";
		case "PENDING_FULFILLMENT":
			return "Pending fulfillment";
		case "RESTOCKED":
			return "Restocked";
		case "SCHEDULED":
			return "Scheduled";
		case "UNFULFILLED":
			return "Unfulfilled";
		default:
			return code;
	}
};

const financial = code => {
	switch (code) {
		case "AUTHORIZED":
			return "Authorized";
		case "PAID":
			return "Paid";
		case "PARTIALLY_PAID":
			return "Partially paid";
		case "PARTIALLY_REFUNDED":
			return "Partially refunded";
		case "PENDING":
			return "Pending";
		case "REFUNDED":
			return "Refunded";
		case "VOIDED":
			return "Voided";
		default:
			return code;
	}
}

function getFormatYYYYMMDD(date) {
    return `${date.getFullYear()}-${('0' + (date.getMonth() + 1)).slice(-2)}-${('0' + date.getDate()).slice(-2)}`;
}


export { price, date, debounce, amount, validPhone, fulfillment, financial };
